import { useEffect } from "react";
import { useGlobalLocalContext } from "src/storage/localStorage";

const DEBUG_MODE_CHARACTER = "D";
const DEBUG_MODE_KEYDOWN_SEQUENCE_LENGTH = 3;
const DEBUG_MODE_KEYDOWN_SEQUENCE_TIMEOUT = 2000;

export const useDebugMode = () =>
  useGlobalLocalContext((state) => state.isDebugMode);

/**
 * Enables debug mode toggle via keyboard shortcut.
 * Press Shift+D three times within 2 seconds to toggle debug mode.
 */
export function useProvideDebugMode() {
  const { toggleDebugMode } = useGlobalLocalContext();

  useEffect(() => {
    let counter = 0;
    let timeout: ReturnType<typeof setTimeout> | null;

    const onKeydown = (e: KeyboardEvent) => {
      if (e.key !== DEBUG_MODE_CHARACTER) {
        return;
      }
      if (counter === DEBUG_MODE_KEYDOWN_SEQUENCE_LENGTH - 1) {
        toggleDebugMode();
        counter = 0;
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = null;
        return;
      }
      if (timeout) {
        clearTimeout(timeout);
      }
      counter = counter ? counter + 1 : 1;
      timeout = setTimeout(() => {
        counter = 0;
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = null;
      }, DEBUG_MODE_KEYDOWN_SEQUENCE_TIMEOUT);
    };

    window.addEventListener("keydown", onKeydown);
    return () => {
      window.removeEventListener("keydown", onKeydown);
    };
  }, [toggleDebugMode]);
}
